// Patrimonial Landscape
export const SET_ID = "SET_ID";
export const UPDATED_AT = "UPDATED_AT";
export const YOUR_INFORMATIONS = "YOUR_INFORMATIONS";
export const YOUR_HOME = "YOUR_HOME";
export const ANNUAL_RECIPE = "ANNUAL_RECIPE";
export const REAL_ESTATE = "REAL_ESTATE";
export const SAVINGS = "SAVINGS";
export const GFR = "GFR";
export const SPENDING_NO_TAXES = "SPENDING_NO_TAXES";
export const CREDITS = "CREDITS";
export const TAXES = "TAXES";
export const ISF = "ISF";
export const RETREAT = "RETREAT";
export const INFLUENCE = "INFLUENCE";
export const FOLLOWING = "FOLLOWING";
export const KNOWLEDGE = "KNOWLEDGE";
export const PERSPECTIVE = "PERSPECTIVE";
export const ESG = "ESG";
export const TOTAL = "TOTAL";
export const CLEAR = "CLEAR";
export const VALIDATION = "VALIDATION";
export const ADVISOR_CHECK = "ADVISOR_CHECK";



// WEBPACK FOOTER //
// ./src/common/store/PatrimonialEstate/types.js